import type {
  Customer,
  CustomerGroup,
  Territory,
  Quotation,
  SalesOrder,
  SalesInvoice,
} from '../types';

// 고객 그룹 - 농산물 박스 고객
export const customerGroups: CustomerGroup[] = [
  { id: 'cooperative', name: '농협/조합', customerCount: 6 },
  { id: 'distributor', name: '유통업체', customerCount: 5 },
  { id: 'farm', name: '농장/작목반', customerCount: 4 },
  { id: 'wholesale', name: '도매상', customerCount: 3 },
];

// 영업 지역
export const territories: Territory[] = [
  { id: 'gyeonggi', name: '경기/수도권', customerCount: 5 },
  { id: 'chungcheong', name: '충청권', customerCount: 4 },
  { id: 'gyeongsang', name: '경상권', customerCount: 4 },
  { id: 'jeolla', name: '전라권', customerCount: 3 },
  { id: 'jeju', name: '제주', customerCount: 2 },
];

// 고객 목록 - 농산물 박스 고객
export const customers: Customer[] = [
  {
    id: 'cust-001',
    code: 'C-001',
    name: '경기농협 광역센터',
    contactPerson: '김농협',
    email: 'kim@gyeongginh.co.kr',
    phone: '031-1234-5678',
    address: '경기도 용인시 처인구 농업로 123',
    territory: 'gyeonggi',
    customerGroup: 'cooperative',
    creditLimit: 200000000,
    outstandingAmount: 28000000,
    isActive: true,
    createdAt: '2024-01-15',
    updatedAt: '2025-01-28',
  },
  {
    id: 'cust-002',
    code: 'C-002',
    name: '안성농협',
    contactPerson: '이안성',
    email: 'lee@ansungnh.co.kr',
    phone: '031-2345-6789',
    address: '경기도 안성시 공도읍 농협로 456',
    territory: 'gyeonggi',
    customerGroup: 'cooperative',
    creditLimit: 100000000,
    outstandingAmount: 12500000,
    isActive: true,
    createdAt: '2024-02-20',
    updatedAt: '2025-01-28',
  },
  {
    id: 'cust-003',
    code: 'C-003',
    name: '제주감귤농협',
    contactPerson: '강제주',
    email: 'kang@jejunh.co.kr',
    phone: '064-3456-7890',
    address: '제주도 서귀포시 남원읍 감귤로 789',
    territory: 'jeju',
    customerGroup: 'cooperative',
    creditLimit: 150000000,
    outstandingAmount: 45000000,
    isActive: true,
    createdAt: '2024-03-10',
    updatedAt: '2025-01-27',
  },
  {
    id: 'cust-004',
    code: 'C-004',
    name: '대구농산물유통센터',
    contactPerson: '박대구',
    email: 'park@daeguagri.com',
    phone: '053-4567-8901',
    address: '대구시 북구 농산물도매시장로 321',
    territory: 'gyeongsang',
    customerGroup: 'distributor',
    creditLimit: 120000000,
    outstandingAmount: 18000000,
    isActive: true,
    createdAt: '2024-01-05',
    updatedAt: '2025-01-28',
  },
  {
    id: 'cust-005',
    code: 'C-005',
    name: '부산청과',
    contactPerson: '최부산',
    email: 'choi@busanfruit.co.kr',
    phone: '051-5678-9012',
    address: '부산시 강서구 명지동 청과로 654',
    territory: 'gyeongsang',
    customerGroup: 'wholesale',
    creditLimit: 80000000,
    outstandingAmount: 8500000,
    isActive: true,
    createdAt: '2024-04-12',
    updatedAt: '2025-01-26',
  },
  {
    id: 'cust-006',
    code: 'C-006',
    name: '논산딸기영농조합',
    contactPerson: '정논산',
    email: 'jung@nonsanstrawberry.kr',
    phone: '041-6789-0123',
    address: '충남 논산시 연산면 딸기로 111',
    territory: 'chungcheong',
    customerGroup: 'farm',
    creditLimit: 50000000,
    outstandingAmount: 15000000,
    isActive: true,
    createdAt: '2024-05-20',
    updatedAt: '2025-01-25',
  },
  {
    id: 'cust-007',
    code: 'C-007',
    name: '나주배작목반',
    contactPerson: '윤나주',
    email: 'yoon@najupear.kr',
    phone: '061-7890-1234',
    address: '전남 나주시 금천면 배로 222',
    territory: 'jeolla',
    customerGroup: 'farm',
    creditLimit: 40000000,
    outstandingAmount: 5500000,
    isActive: true,
    createdAt: '2024-06-15',
    updatedAt: '2025-01-24',
  },
  {
    id: 'cust-008',
    code: 'C-008',
    name: '가락시장농산물유통',
    contactPerson: '임가락',
    email: 'lim@garakmarket.co.kr',
    phone: '02-8901-2345',
    address: '서울시 송파구 가락동 농수산물시장로 333',
    territory: 'gyeonggi',
    customerGroup: 'wholesale',
    creditLimit: 180000000,
    outstandingAmount: 32000000,
    isActive: true,
    createdAt: '2024-07-01',
    updatedAt: '2025-01-28',
  },
  {
    id: 'cust-009',
    code: 'C-009',
    name: '상주사과영농조합',
    contactPerson: '한상주',
    email: 'han@sangjuapple.kr',
    phone: '054-9012-3456',
    address: '경북 상주시 사벌면 사과로 444',
    territory: 'gyeongsang',
    customerGroup: 'farm',
    creditLimit: 60000000,
    outstandingAmount: 12000000,
    isActive: true,
    createdAt: '2024-08-10',
    updatedAt: '2025-01-27',
  },
  {
    id: 'cust-010',
    code: 'C-010',
    name: '청송사과농협',
    contactPerson: '송청송',
    email: 'song@cheongsongnh.co.kr',
    phone: '054-0123-4567',
    address: '경북 청송군 현서면 사과골로 555',
    territory: 'gyeongsang',
    customerGroup: 'cooperative',
    creditLimit: 90000000,
    outstandingAmount: 22000000,
    isActive: true,
    createdAt: '2024-09-05',
    updatedAt: '2025-01-28',
  },
];

// 견적서 목록
export const quotations: Quotation[] = [
  {
    id: 'qtn-001',
    quotationNo: 'QTN-20250125-0001',
    customerId: 'cust-001',
    customerName: '경기농협 광역센터',
    items: [
      { itemId: 'item-001', itemCode: 'BOX-A10', itemName: '사과박스 10kg', quantity: 5000, unitPrice: 2800, discount: 5, amount: 13300000 },
      { itemId: 'item-002', itemCode: 'BOX-A05', itemName: '사과박스 5kg', quantity: 3000, unitPrice: 2200, discount: 5, amount: 6270000 },
    ],
    subtotal: 19570000,
    tax: 1957000,
    discount: 978500,
    total: 20548500,
    validUntil: '2025-02-25',
    status: 'open',
    notes: '수확철 대량 구매 할인 적용',
    createdBy: '홍길동',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-25',
  },
  {
    id: 'qtn-002',
    quotationNo: 'QTN-20250126-0001',
    customerId: 'cust-003',
    customerName: '제주감귤농협',
    items: [
      { itemId: 'item-006', itemCode: 'BOX-C20', itemName: '감귤박스 20kg', quantity: 10000, unitPrice: 3200, discount: 8, amount: 29440000 },
    ],
    subtotal: 29440000,
    tax: 2944000,
    discount: 2355200,
    total: 30028800,
    validUntil: '2025-02-26',
    status: 'ordered',
    createdBy: '김철수',
    createdAt: '2025-01-26',
    updatedAt: '2025-01-27',
  },
  {
    id: 'qtn-003',
    quotationNo: 'QTN-20250127-0001',
    customerId: 'cust-006',
    customerName: '논산딸기영농조합',
    items: [
      { itemId: 'item-008', itemCode: 'BOX-S03', itemName: '딸기박스 3kg', quantity: 8000, unitPrice: 2000, discount: 5, amount: 15200000 },
    ],
    subtotal: 15200000,
    tax: 1520000,
    discount: 760000,
    total: 15960000,
    validUntil: '2025-02-27',
    status: 'draft',
    createdBy: '박물류',
    createdAt: '2025-01-27',
    updatedAt: '2025-01-27',
  },
  {
    id: 'qtn-004',
    quotationNo: 'QTN-20250128-0001',
    customerId: 'cust-007',
    customerName: '나주배작목반',
    items: [
      { itemId: 'item-003', itemCode: 'BOX-P15', itemName: '배박스 15kg', quantity: 2000, unitPrice: 3500, discount: 0, amount: 7000000 },
    ],
    subtotal: 7000000,
    tax: 700000,
    discount: 0,
    total: 7700000,
    validUntil: '2025-02-28',
    status: 'submitted',
    createdBy: '홍길동',
    createdAt: '2025-01-28',
    updatedAt: '2025-01-28',
  },
];

// 판매 주문 목록
export const salesOrders: SalesOrder[] = [
  {
    id: 'so-001',
    orderNo: 'SO-2025-001',
    customerId: 'cust-009',
    customerName: '상주사과영농조합',
    items: [
      { itemId: 'item-001', itemCode: 'BOX-A10', itemName: '사과박스 10kg', quantity: 2000, deliveredQty: 2000, unitPrice: 2800, discount: 3, amount: 5432000 },
      { itemId: 'item-002', itemCode: 'BOX-A05', itemName: '사과박스 5kg', quantity: 1500, deliveredQty: 1500, unitPrice: 2200, discount: 3, amount: 3201000 },
    ],
    subtotal: 8633000,
    tax: 863300,
    discount: 258990,
    total: 9237310,
    deliveryDate: '2025-01-20',
    status: 'completed',
    paymentStatus: 'paid',
    deliveryStatus: 'delivered',
    createdBy: '홍길동',
    createdAt: '2025-01-15',
    updatedAt: '2025-01-28',
  },
  {
    id: 'so-002',
    orderNo: 'SO-2025-002',
    customerId: 'cust-003',
    customerName: '제주감귤농협',
    quotationId: 'qtn-002',
    items: [
      { itemId: 'item-006', itemCode: 'BOX-C20', itemName: '감귤박스 20kg', quantity: 10000, deliveredQty: 3000, unitPrice: 3200, discount: 8, amount: 29440000 },
    ],
    subtotal: 29440000,
    tax: 2944000,
    discount: 2355200,
    total: 30028800,
    deliveryDate: '2025-02-15',
    status: 'to_deliver',
    paymentStatus: 'partial',
    deliveryStatus: 'partial',
    notes: '1차 3,000개 출고 완료, 2차 7,000개 예정',
    createdBy: '김철수',
    createdAt: '2025-01-27',
    updatedAt: '2025-01-28',
  },
  {
    id: 'so-003',
    orderNo: 'SO-2025-003',
    customerId: 'cust-001',
    customerName: '경기농협 광역센터',
    items: [
      { itemId: 'item-001', itemCode: 'BOX-A10', itemName: '사과박스 10kg', quantity: 3000, deliveredQty: 0, unitPrice: 2800, discount: 5, amount: 7980000 },
      { itemId: 'item-004', itemCode: 'BOX-G05', itemName: '포도박스 5kg', quantity: 2000, deliveredQty: 0, unitPrice: 2500, discount: 5, amount: 4750000 },
    ],
    subtotal: 12730000,
    tax: 1273000,
    discount: 636500,
    total: 13366500,
    deliveryDate: '2025-02-05',
    status: 'to_deliver',
    paymentStatus: 'unpaid',
    deliveryStatus: 'not_delivered',
    createdBy: '박물류',
    createdAt: '2025-01-27',
    updatedAt: '2025-01-27',
  },
  {
    id: 'so-004',
    orderNo: 'SO-2025-004',
    customerId: 'cust-008',
    customerName: '가락시장농산물유통',
    items: [
      { itemId: 'item-009', itemCode: 'BOX-V10', itemName: '채소박스 10kg', quantity: 5000, deliveredQty: 0, unitPrice: 2400, discount: 5, amount: 11400000 },
    ],
    subtotal: 11400000,
    tax: 1140000,
    discount: 570000,
    total: 11970000,
    deliveryDate: '2025-02-10',
    status: 'submitted',
    paymentStatus: 'unpaid',
    deliveryStatus: 'not_delivered',
    createdBy: '홍길동',
    createdAt: '2025-01-27',
    updatedAt: '2025-01-27',
  },
  {
    id: 'so-005',
    orderNo: 'SO-2025-005',
    customerId: 'cust-010',
    customerName: '청송사과농협',
    items: [
      { itemId: 'item-001', itemCode: 'BOX-A10', itemName: '사과박스 10kg', quantity: 4000, deliveredQty: 4000, unitPrice: 2800, discount: 5, amount: 10640000 },
    ],
    subtotal: 10640000,
    tax: 1064000,
    discount: 532000,
    total: 11172000,
    deliveryDate: '2025-01-22',
    status: 'to_bill',
    paymentStatus: 'unpaid',
    deliveryStatus: 'delivered',
    createdBy: '김철수',
    createdAt: '2025-01-16',
    updatedAt: '2025-01-26',
  },
  {
    id: 'so-006',
    orderNo: 'SO-2025-006',
    customerId: 'cust-006',
    customerName: '논산딸기영농조합',
    items: [
      { itemId: 'item-008', itemCode: 'BOX-S03', itemName: '딸기박스 3kg', quantity: 6000, deliveredQty: 6000, unitPrice: 2000, discount: 3, amount: 11640000 },
    ],
    subtotal: 11640000,
    tax: 1164000,
    discount: 349200,
    total: 12454800,
    deliveryDate: '2025-01-18',
    status: 'completed',
    paymentStatus: 'paid',
    deliveryStatus: 'delivered',
    createdBy: '박물류',
    createdAt: '2025-01-10',
    updatedAt: '2025-01-28',
  },
];

// 판매 청구서 목록
export const salesInvoices: SalesInvoice[] = [
  {
    id: 'inv-001',
    invoiceNo: 'INV-2025-001',
    customerId: 'cust-009',
    customerName: '상주사과영농조합',
    salesOrderId: 'so-001',
    items: [
      { itemId: 'item-001', itemCode: 'BOX-A10', itemName: '사과박스 10kg', quantity: 2000, unitPrice: 2800, discount: 3, amount: 5432000 },
      { itemId: 'item-002', itemCode: 'BOX-A05', itemName: '사과박스 5kg', quantity: 1500, unitPrice: 2200, discount: 3, amount: 3201000 },
    ],
    subtotal: 8633000,
    tax: 863300,
    discount: 258990,
    total: 9237310,
    paidAmount: 9237310,
    outstandingAmount: 0,
    dueDate: '2025-02-15',
    status: 'paid',
    createdBy: '홍길동',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-28',
  },
  {
    id: 'inv-002',
    invoiceNo: 'INV-2025-002',
    customerId: 'cust-003',
    customerName: '제주감귤농협',
    salesOrderId: 'so-002',
    items: [
      { itemId: 'item-006', itemCode: 'BOX-C20', itemName: '감귤박스 20kg', quantity: 3000, unitPrice: 3200, discount: 8, amount: 8832000 },
    ],
    subtotal: 8832000,
    tax: 883200,
    discount: 706560,
    total: 9008640,
    paidAmount: 5000000,
    outstandingAmount: 4008640,
    dueDate: '2025-02-20',
    status: 'partial',
    notes: '1차 부분 결제 완료, 잔금 결제 예정',
    createdBy: '김철수',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-27',
  },
  {
    id: 'inv-003',
    invoiceNo: 'INV-2025-003',
    customerId: 'cust-008',
    customerName: '가락시장농산물유통',
    items: [
      { itemId: 'item-005', itemCode: 'BOX-T10', itemName: '토마토박스 10kg', quantity: 3000, unitPrice: 2600, discount: 3, amount: 7566000 },
    ],
    subtotal: 7566000,
    tax: 756600,
    discount: 226980,
    total: 8095620,
    paidAmount: 0,
    outstandingAmount: 8095620,
    dueDate: '2025-01-20',
    status: 'overdue',
    notes: '결제 독촉 필요',
    createdBy: '박물류',
    createdAt: '2025-01-05',
    updatedAt: '2025-01-28',
  },
  {
    id: 'inv-004',
    invoiceNo: 'INV-2025-004',
    customerId: 'cust-006',
    customerName: '논산딸기영농조합',
    salesOrderId: 'so-006',
    items: [
      { itemId: 'item-008', itemCode: 'BOX-S03', itemName: '딸기박스 3kg', quantity: 6000, unitPrice: 2000, discount: 3, amount: 11640000 },
    ],
    subtotal: 11640000,
    tax: 1164000,
    discount: 349200,
    total: 12454800,
    paidAmount: 12454800,
    outstandingAmount: 0,
    dueDate: '2025-02-18',
    status: 'paid',
    createdBy: '홍길동',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-28',
  },
  {
    id: 'inv-005',
    invoiceNo: 'INV-2025-005',
    customerId: 'cust-010',
    customerName: '청송사과농협',
    salesOrderId: 'so-005',
    items: [
      { itemId: 'item-001', itemCode: 'BOX-A10', itemName: '사과박스 10kg', quantity: 4000, unitPrice: 2800, discount: 5, amount: 10640000 },
    ],
    subtotal: 10640000,
    tax: 1064000,
    discount: 532000,
    total: 11172000,
    paidAmount: 0,
    outstandingAmount: 11172000,
    dueDate: '2025-02-22',
    status: 'unpaid',
    createdBy: '김철수',
    createdAt: '2025-01-28',
    updatedAt: '2025-01-28',
  },
];

// 헬퍼 함수들
export function getCustomerById(id: string): Customer | undefined {
  return customers.find((c) => c.id === id);
}

export function getQuotationById(id: string): Quotation | undefined {
  return quotations.find((q) => q.id === id);
}

export function getSalesOrderById(id: string): SalesOrder | undefined {
  return salesOrders.find((so) => so.id === id);
}

export function getSalesInvoiceById(id: string): SalesInvoice | undefined {
  return salesInvoices.find((inv) => inv.id === id);
}

export function getCustomerOrders(customerId: string): SalesOrder[] {
  return salesOrders.filter((so) => so.customerId === customerId);
}

export function getCustomerInvoices(customerId: string): SalesInvoice[] {
  return salesInvoices.filter((inv) => inv.customerId === customerId);
}

export function getPendingOrders(): SalesOrder[] {
  return salesOrders.filter((so) => so.status === 'to_deliver' || so.status === 'submitted');
}

export function getOverdueInvoices(): SalesInvoice[] {
  return salesInvoices.filter((inv) => inv.status === 'overdue');
}

export function getSalesSummary() {
  const totalSales = salesInvoices
    .filter((inv) => inv.status === 'paid')
    .reduce((sum, inv) => sum + inv.total, 0);

  const totalOrders = salesOrders.length;
  const avgOrderValue = totalOrders > 0
    ? salesOrders.reduce((sum, so) => sum + so.total, 0) / totalOrders
    : 0;

  const pendingOrders = salesOrders.filter(
    (so) => so.status === 'to_deliver' || so.status === 'submitted'
  ).length;

  const overdueInvoices = salesInvoices.filter((inv) => inv.status === 'overdue').length;

  const outstandingAmount = salesInvoices.reduce(
    (sum, inv) => sum + inv.outstandingAmount,
    0
  );

  return {
    totalSales,
    totalOrders,
    avgOrderValue,
    pendingOrders,
    overdueInvoices,
    outstandingAmount,
  };
}
